import { MessageSquareText, ClipboardCheck, RefreshCcw, CircleCheckBig } from "lucide-react";

const STEPS = [
  {
    icon: MessageSquareText,
    step: "01",
    title: "Isi Form atau Chat WhatsApp",
    desc: "Kirim nama, nomor IndiHome, dan paket kamu saat ini. Tanpa ribet, tanpa antre.",
  },
  {
    icon: ClipboardCheck,
    step: "02",
    title: "Kami Cek Kelayakan Retensi",
    desc: "Tim kami cek paket retensi terbaik yang tersedia untuk nomor IndiHome kamu.",
  },
  {
    icon: RefreshCcw,
    step: "03",
    title: "Proses Migrasi Paket",
    desc: "Pengajuan migrasi diproses langsung. Kamu cukup duduk santai, kami yang urus.",
  },
  {
    icon: CircleCheckBig,
    step: "04",
    title: "Tagihan Langsung Turun",
    desc: "Paket retensi aktif. Karena sistem pascabayar, bulan pertama masih prorata — bulan kedua full harga paket baru yang lebih murah.",
  },
];

export const HowItWorks = () => {
  return (
    <section
      id="cara-kerja"
      data-testid="how-it-works-section"
      className="py-20 md:py-32 bg-[#F8F9FA]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="max-w-2xl">
          <p className="text-xs md:text-sm font-semibold uppercase tracking-widest text-[#E60000]">
            Cara Kerja
          </p>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl tracking-tight font-bold text-gray-900 mt-4">
            Dari Chat ke Tagihan Murah, Hanya 4 Langkah
          </h2>
          <p className="text-base text-gray-600 mt-4 leading-relaxed">
            Semua dikerjakan remote — kamu tidak perlu ke gerai, tidak perlu
            telepon call center sendiri.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
          {STEPS.map((s, i) => (
            <div
              key={s.step}
              data-testid={`how-it-works-step-${i + 1}`}
              className="bg-white rounded-2xl border border-black/10 p-8 hover:-translate-y-1 hover:shadow-lg transition-[transform,box-shadow] duration-300"
            >
              <div className="flex items-center justify-between">
                <span className="w-12 h-12 rounded-xl bg-red-50 flex items-center justify-center">
                  <s.icon className="w-6 h-6 text-[#E60000]" strokeWidth={2} />
                </span>
                <span className="font-heading font-black text-3xl text-gray-200">
                  {s.step}
                </span>
              </div>
              <h3 className="font-heading text-xl font-semibold text-gray-900 mt-6">
                {s.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed mt-3">
                {s.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 rounded-3xl overflow-hidden relative">
          <img
            src="https://images.pexels.com/photos/7682476/pexels-photo-7682476.jpeg?auto=compress&cs=tinysrgb&w=1400"
            alt="Tim RismaCell siap membantu proses migrasi dengan respon cepat"
            data-testid="how-it-works-image"
            className="w-full h-56 md:h-72 object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent flex items-center">
            <p className="font-heading text-white font-bold text-xl md:text-2xl px-8 md:px-12 max-w-md leading-snug">
              Respon cepat. Kamu dibantu sampai benar-benar selesai.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
